var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProjectInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2706_7008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49935 6.16667V15H1.16602V16H9.49935V15H6.49935V6.16667H12.666V6.83333L12.166 6.83333L12.166 7.83333L12.916 7.83333L12.7094 8.29622L13.6226 8.70379L13.6236 8.70163C13.6374 8.71482 13.651 8.72906 13.6645 8.74439C13.7768 8.87187 13.8327 9.02694 13.8327 9.14359C13.8327 9.34032 13.6473 9.56667 13.3327 9.56667C13.0181 9.56667 12.8327 9.34032 12.8327 9.14359H11.8327C11.8327 9.96646 12.5427 10.5667 13.3327 10.5667C14.1227 10.5667 14.8327 9.96646 14.8327 9.14359C14.8327 8.75044 14.6647 8.36705 14.415 8.08352C14.3106 7.96493 14.1844 7.85571 14.04 7.76852L14.4574 6.83333L13.666 6.83333V6.16667H15.8824L14.2824 3.5H13.0879L6.49935 1.08954V0H5.49935V15H4.49935V0H3.49935V1.2658L0.818308 3.5H0.166016V6.16667H3.49935ZM6.49935 2.15436V3.5H10.1774L6.49935 2.15436ZM2.38036 3.5L3.49935 2.56751V3.5H2.38036ZM14.1163 5.16667H6.49935V4.5H13.7163L14.1163 5.16667ZM3.49935 5.16667V4.5H1.16602V5.16667H3.49935Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_7008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectInfo);
export default __webpack_public_path__ + "static/media/icon--project-info.290d2927a475c2cac3dbd57cabf26713.svg";
export { ForwardRef as ReactComponent };